import React from "react";
import { QuickReply } from "../../../types/message";

interface QuickReplyListProps {
  visible: boolean;
  search: string;
  items: QuickReply[];
  onSelect: (text: string) => void;
}

const QuickReplyList: React.FC<QuickReplyListProps> = ({
  visible,
  search,
  items,
  onSelect,
}) => {
  if (!visible) return null;

  const filtered = items.filter(item =>
    item.name.toLowerCase().includes(search.toLowerCase())
  );

  return (
    <>
      {/* 🎨 CSS EMBUTIDO */}
      <style>
        {`
          .quick-reply-dropdown {
            position: absolute;
            bottom: 64px;
            left: 0;
            width: 100%;
            max-height: 240px;
            overflow-y: auto;
            background: #fff;
            border: 1px solid #e5e7eb;
            border-radius: 10px;
            z-index: 999;
            box-shadow: 0 6px 20px rgba(0, 0, 0, 0.08);
          }

          .quick-reply-item {
            padding: 10px 12px;
            cursor: pointer;
            transition: background 0.15s ease;
          }

          .quick-reply-item:hover {
            background: #f8f9fa;
          }

          .quick-reply-key {
            font-weight: 600;
            color: #0d6efd;
          }

          .quick-reply-text {
            font-size: 12px;
            color: #6c757d;
          }

          .quick-reply-empty {
            padding: 12px;
            text-align: center;
            color: #adb5bd;
            font-size: 13px;
          }
        `}
      </style>

      <div className="quick-reply-dropdown">
        {filtered.length === 0 && (
          <div className="quick-reply-empty">
            Nenhuma resposta encontrada
          </div>
        )}

        {filtered.map(item => (
          <div
            key={item.id}
            className="quick-reply-item"
            onClick={() => onSelect(item.description)}
          >
            <div className="quick-reply-key">/{item.name}</div>
            <div className="quick-reply-text">{item.description}</div>
          </div>
        ))}
      </div>
    </>
  );
};

export default QuickReplyList;
